<template>
  <div>
    <date-picker
    class="tgo-date-picker"
    :type="type"
    :value="ivalue"
    :format="type==='year'?'yyyy':'yyyy-MM-dd'"
    :placeholder="placeholder"
    :options="options1"
    :start-date="new Date(2000, 0, 1)"
    @on-change="onChange"
    @on-open-change="onOpenChange"
    :size="size"
    ></date-picker>
  </div>
</template>
<script>
// import { DatePicker } from 'iview'
import DatePicker from '../iview/components/date-picker'
import moment from 'moment'
export default {
  data () {
    return {
      ivalue: !this.value ? '' : moment.unix(Number(this.value)).format('YYYY-MM-DD'),
      options1: {
        disabledDate (date) {
          return date && date.valueOf() < 1
        }
      }
    }
  },
  components: {
    DatePicker
  },
  props: ['tKey', 'type', 'placeholder', 'value', 'size'],
  methods: {
    onOpenChange (state) {
      if (state) {
        this.$emit('focus')
      } else {
        this.$emit('blur')
      }
    },
    onChange (date) {
      let dateValue = ''
      if (date) {
        dateValue = Date.parse(date) / 1000
      } else {
        dateValue = ''
      }
      this.$emit('input', { 'key': this.tKey, 'value': dateValue })
      this.$emit('blur')
    }
  },
  watch: {
    'value': function (newVal) {
      this.ivalue = !newVal ? '' : moment.unix(Number(newVal)).format('YYYY-MM-DD')
    }
  }
  // computed: {
  //   ivalue () {
  //     console.log(this.value)
  //     return !this.value ? '' : moment.unix(Number(this.value)).format('YYYY-MM-DD')
  //   }
  // }
}
</script>
<style lang="sass">

.tgo-date-picker
  font-size: 12px
  width: 216px
  // &.ivu-date-picker-focused
    // input
      // box-shadow: none
  // .ivu-input
    // border: none
    // padding: 0
    // &:focus
      // box-shadow: none
</style>
